import {
  InputLabel,
  FormGroup,
  Paper,
  TextField,
  Typography,
  FormControlLabel,
  Button,
  Checkbox,
  Select,
  MenuItem,
  FormControl,
  Table,
  TableRow,
  TableCell,
  TableHead, TableBody, FormHelperText,
  TableContainer
} from "@material-ui/core";
import DateCalc from "./date";
import { Dialog } from "@mui/material";
import { makeStyles } from "@material-ui/core/styles";
import { useState, useEffect } from "react";
import GetRole from "./user";
import {svtoken} from "../api/customerapi";
import {getLastTenChars, checkDate, sslist, newgetqualitylead, removeDuplicatesmulti2, getempTL} from "./date.js"
import axios from "axios"
import { red } from "@material-ui/core/colors";
import { fetchLeadbyId, updateLeaddata, fetchRules, getinsightviaapi, startclaudecallinsight, getclaudecallinsightstatus, fetchDest, gmailSend, fetchEmployeebyName, makecall, addLead, fetchtriphistory, fetchCustomerbyNumber, checkfastreach } from "../api/customerapi";
import { styled } from '@mui/system';

const useStyles = makeStyles((theme) => ({
  paper: {
    marginLeft: theme.spacing(10),
    marginRight: theme.spacing(10),
    justifyContent: "center",
    backgroundColor: "#f8f8f8",
  },
  smallbutton: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(4),
    width: theme.spacing(20),
    height: theme.spacing(4),
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(4),
    width: theme.spacing(60),
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  textField2: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(4),
    width: theme.spacing(20),
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  headertext: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  formgroup: {
    justifyContent: "center",
  },
  textArea: {
    marginLeft: theme.spacing(12),
    marginRight: theme.spacing(14),
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  textArea2: {
    marginLeft: theme.spacing(4),
    width: theme.spacing(168),
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  button: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(4),
    width: theme.spacing(24),
    height: theme.spacing(6),
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  smallbutton2: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(4),
    width: theme.spacing(10),
    height: theme.spacing(4),
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  headtext: {
    marginLeft: theme.spacing(2),
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    
  },
  red: {
    color:red
  },
  redheadtext: {
    marginLeft: theme.spacing(2),
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(2),
    justifyContent:"center",
    border: "red solid 2px"
  },
  bodytext: {
    marginLeft: theme.spacing(5),
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  bodytext2: {
    marginLeft: theme.spacing(5),
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
    color:red,
    backgroundColor: "#f94449",
  },
}));

const Leaddataupdate = () => {
  const classes = useStyles();
  const currenturl = window.location.href;
  const urlarray = currenturl.split("/");
  const currentid = urlarray[urlarray.length - 1];
  const { cuser, role, employeelist, destinationlist, loading } = GetRole();
  const [emp, setemp]=useState([])
  const [emp2, setemp2]=useState([])
  const [emplist, setemplist]=useState([])
  const [oldowner, setoldowner]=useState(null)
  const [oldstatus, setoldstatus]=useState(null)
  const [insight, setinsight]=useState(null)
  const [dest, setdest]=useState([])
  const [destarr, setdestarr]=useState([])
  const [Open6, setOpen6] = useState(false);
  const [Open5, setOpen5] = useState(false);
  const [Open4, setOpen4] = useState(false);
  const [Open3, setOpen3] = useState(false);
  const [createcustflag, setcreatecustflag] = useState(false);
  const [callcriteria, setcallcriteria] = useState(false);
  const [callcriteria2, setcallcriteria2] = useState(false);
  const [calldata, setcalldata] = useState(false);
  const [Attempted, setAttempted] = useState(false);
  const [showlead, setshowlead] = useState(false);
  const [spcalled, setspcalled] = useState(false);
  const [leadfilterData, setleadfilterData]=useState({})
  const [triphistory, settriphistory]=useState({})
   const [showsh, setshowsh] = useState(false);
  const [leadData, setleadData] = useState({
    lead_name: "",
    mobile_number: 0,
    email_id: "",
    lead_status: "",
    lead_budget:"",
    lead_campaign: "",
    lead_platform: "",
    lead_sub_platform:"",
    lead_ad:"",
    lead_destination: "",
    lead_pax: "",
    lead_travel_date: "",
    lead_travel_date_decided: "",
    lead_id: 0,
    lead_owner: "",
    work_complete: false,
    cust_create: true,
    potential:false,
    quality_upgrade:false,
    canc_reason: "",
    //work_complete_date:"",
    canc_reason_notes: "",
    ref_code:"",
  });
  var q
  //const { appData, loading } = useAppData();

  const BlinkingText = styled(Typography)({
    // animation: 'blink 1s steps(2, start) infinite',
    // '@keyframes blink': {
    //   to: { visibility: 'hidden' },
    // },
    color: 'red',
    animation: 'slowBlink 2s ease-in-out infinite',
  '@keyframes slowBlink': {
    '0%, 100%': { opacity: 1 },
    '50%': { opacity: 0 },
  },
  });

  const getLead = async (id) => {
    try{
    const data = await fetchLeadbyId(id);
    console.log(id)
    console.log(data.data)
    let urlbreakup="", urlbreakup2=""
    if(data.data.current_url){
      //console.log(data.data.current_url)
      let result = data.data.current_url.includes("FB_Ads");
      if(result){
        data.data.lead_platform="Meta"
      if(data.data.current_url.includes("QRcode")){
        urlbreakup=data.data.current_url.split("QRcode")
        urlbreakup2=urlbreakup[1].split("&")
      }else{
        if(data.data.current_url.includes("Ad_Set=")){
          urlbreakup=data.data.current_url.split("Ad_Set=")
          urlbreakup2=urlbreakup[1].split("&")
        }else{
          urlbreakup=data.data.current_url.split("utm_campaign=")
          urlbreakup2=urlbreakup[1].split("&")
        }
        
      }
     
      //console.log(urlbreakup2)
      data.data.lead_campaign=urlbreakup2[0]
      }
    }
   q=newgetqualitylead(data.data)
    console.log(q)
    setoldowner(data.data.lead_owner)
    setoldstatus(data.data.work_complete)
    if(!("cust_create" in data.data)){
      data.data.cust_create=true
    }
    setleadData(data.data);
    if(!("customer_type" in data.data)){
    const tripData=await fetchtriphistory(Number(data.data.mobile_number))
    //console.log(tripData.data)
    settriphistory(tripData.data)
    
    
    }
    if("callrecord" in data.data && data.data.callrecord.length>1){
      var count=0, countss=0
      for (let i=0;i<data.data.callrecord.length;i++){
        if(sslist.includes(data.data.callrecord[i].answered_agent_name)){
          if(data.data.callrecord[i].call_status=="answered" || data.data.callrecord[i].hangup_cause=="chanunavail" ||
                data.data.callrecord[i].hangup_cause == "noanswer" ||
                data.data.callrecord[i].hangup_cause == "User busy" ||
                data.data.callrecord[i].hangup_cause == "missed" ){
            countss=countss+2
          }else{
          if(Number(data.data.callrecord[i].duration)>14){
              countss++
          }
        }
        }else{
          if(data.data.callrecord[i].call_status=="answered" || data.data.callrecord[i].hangup_cause=="chanunavail" ||
                data.data.callrecord[i].hangup_cause == "noanswer" ||
                data.data.callrecord[i].hangup_cause == "User busy" ||
                data.data.callrecord[i].hangup_cause == "missed"){
            count=count+2
          }else{
          if(Number(data.data.callrecord[i].duration)>14){
            count=count+2
          }else{
            count++
          }
        }
        }
      }
      if(count>1){
        setcallcriteria(true)
      }
      
      if(countss>1){
        setcallcriteria2(true)
      }
    }

    //console.log(role)
    var emp=employeelist.filter(e=>e.short_name==data.data.lead_owner)
    if(role=="Sales"){
      if(data.data.lead_owner==cuser){
      setshowlead(true)
      }
    }else if(role=="TL" && cuser!=="Tarun"){
      if(emp.length>0 && emp[0].reporting_manager==cuser){
      setshowlead(true)
      }
    }else{
      setshowlead(true)
    }
    
    var flag=emp.length>0 && "permissions" in emp[0] && "callmust" in emp[0].permissions?emp[0].permissions.callmust:false
    setcreatecustflag(flag)
    if(data.data.callrecord.length>0){
      var numspcalls=data.data.callrecord.filter(c=>c.answered_agent_name==data.data.lead_owner)
      if(numspcalls.length>0){
        setspcalled(true)
      }
    }
  }catch(err){
    console.log(err)
  }
  };
  console.log("Call Crietria 1, 2: "+callcriteria+callcriteria2)
  console.log("SP Called: "+spcalled)

  const getEmployees = async () => {
    try{
    // const data = await fetchEmployees();
    //const custdatalistfromdb= data.data
    setemplist(employeelist)
    const empsplist = employeelist.filter((emp) => emp.role == "Sales" || emp.role=="TL" || emp.role=="SME");
    const empshortname = empsplist.map((emp) => emp.short_name);
    let sortedemp = empshortname.sort()
    setemp(sortedemp);

    const empsplist2 = employeelist.filter((emp) => emp.role == "Sales Support");
    const empshortname2 = empsplist2.map((emp) => emp.short_name);
    let sortedemp2 = empshortname2.sort()
    setemp2(sortedemp2);
  }catch(err){
    console.log(err)
  }
  };

    const getDest = async () => {
    try{
    // const data = await fetchDest();
    // const temp=data.data.filter(d=>"order" in d)
    // setdest(temp[0].dest);
    //console.log(destinationlist)
    setdest(destinationlist);
  }catch(err){
    console.log(err)
  }
  }; 
   
  useEffect(() => {
    if(!loading){
    getLead(currentid);
    getEmployees()
    getDest()
    }
  }, [role, cuser, loading, employeelist, destinationlist]);

  
  //console.log(cuser, role)
  const apicall=async()=>{
    //setAttempted(true)
    const emp=emplist.filter(e=>e.short_name==cuser && e.role !=="Ex-employee")
    //console.log(cuser)
    //console.log(emp)
    if(leadData.mobile_number && emp[0].contact){
    const calldata={
      emp_number:String(emp[0].contact),
      entity_type:"Lead",
      entity_id:leadData.lead_id,
      cust_number:String(leadData.mobile_number),
      token:svtoken,
    }
   // console.log(calldata)
    try{
    const responsedata=await makecall(calldata)
    //console.log(responsedata.data)
    
    if(responsedata.data.message=="Originate successfully queued"){
      setAttempted(true)
      setOpen5(true)
      //window.location.reload()
    }
    alert(responsedata.data.message)
    }catch(error){
      console.log(error)
      setAttempted(true)
      alert("Error: Call manually ")
      //window.location.reload()
    }
  }else{
    alert("Try again")
  }
  }

  const viewstatushistory=async()=>{
  //const metadata=await sendpurchasetoMeta(tripData)
  setshowsh(true)
}

  const handleSubmit = async (e) => {
    try{
    e.preventDefault();
    let flag=0
    let flag2=0
    let flag3=0
    
    if(role=="Sales"){
    const temp=getLastTenChars(leadData.mobile_number.toString())
    const data=await fetchCustomerbyNumber(temp)
    console.log(data.data)
    if(data.data.length==0){
      flag=1
      alert("No customer found")
    }else{
      // var newcustdata={...data.data[0], follow_up:{status:"Open", roc:"", owner:leadData.lead_owner}}
      // console.log(newcustdata)
      flag3=data.data[0].cust_id
    }
    if(!("potential" in leadData)){
    var p=window.confirm("Is this a potential lead?")
    if(p){
      leadData.potential=true
    }
    }
    }
     //TL can assign within his team
    if(role=="TL" && cuser!=="Tarun" && oldowner!==leadData.lead_owner){
      if(getempTL(oldowner,employeelist) !==getempTL(leadData.lead_owner,employeelist)){
        alert("TL mismatch between old and new lead owner")
        return
      }
      const ruledata = await fetchRules();
      const sp=ruledata.data[0].leadrule.filter(r=>r.name==leadData.lead_owner)
        if(sp.length>0){
           if(!sp[0].destinations.includes(leadData.lead_destination)){
        alert("Connot assign leads of "+leadData.lead_destination+" to "+leadData.lead_owner)
      }
        }
      //console.log(ruledata.data)
     
    }
    //double ensure that HQ lead do not get marked Titanium
    if((newgetqualitylead(leadData)=="Gold" || newgetqualitylead(leadData)=="Diamond" || newgetqualitylead(leadData)=="Rhodium" || newgetqualitylead(leadData)=="Platinum") && leadData.quality_upgrade){
      leadData.quality_upgrade=false
    }
   
    if(!(role=="Admin" || role=="Marketing") && calldata==false && "lead_budget"  in leadData && leadData.lead_budget=="Unable to confirm"){
      var x=prompt("Why are you unable to confirm budget?")
    }
   
if(leadData.lead_destination=="" || leadData.lead_owner==""){
  alert("Destination or Owner missing. Enter data")
  flag=1
}

    if(new Date(leadData.createdAt).getTime()>new Date("2024-11-03").getTime()){
      console.log(leadData.work_complete)
      if(("work_complete" in leadData && leadData.work_complete && "lead_budget" in leadData && leadData.lead_budget=="") || ("work_complete" in leadData && leadData.work_complete && !("lead_budget" in leadData))){
        console.log(leadData)
        flag=1
      }
    }
    console.log(flag)
    var history={}
    if(cuser=="AjeetAnand" || !flag){
    
    if (leadData.lead_owner !== oldowner){
      if(cuser=="AjeetAnand") return
      history={
      changed_by:cuser,
      old_owner:oldowner,
      new_owner:leadData.lead_owner,
      changedAt:new Date(),
      }
      leadData.lead_assigned_by=cuser
      leadData.assignedAt=new Date()
    }
    var newhistory="change_history" in leadData && leadData.change_history.length>0?[...leadData.change_history,history]:[history]
    if(!leadData.cust_create){
      if(leadData.canc_reason=="Number unreachable"){
        var text=`Greetings from Jeto Vacations!`+`%0a%0a`+`We tried contacting you about your upcoming trip to ${leadData.lead_destination} but your number seems unreachable. Please reply if you are still interested in your trip`
        var win = window.open(
          `https://wa.me/91${leadData.mobile_number}?text=${text}`,
          "_blank"
        );
      }else if(leadData.canc_reason=="Cancelled by marketing" || leadData.canc_reason=="Others" ){
        var text=`Greetings from Jeto Vacations!`+`%0a%0a`+`We are sorry that we are unable to serve you at this moment. Please do let us know if there is any change in your plans`
        var win = window.open(
          `https://wa.me/91${leadData.mobile_number}?text=${text}`,
          "_blank"
        );
      }else if(leadData.canc_reason=="" || !("canc_reason" in leadData)){
        alert("Cancellation reason not found. Please enter reason and try again")
        flag2=1
      }
    }
    leadData.updatedAt=new Date()
    if(oldstatus==false && leadData.work_complete==true){
      //console.log("True")
      leadData.work_complete_date=new Date()
    }
   

    var finalleadData={}
    finalleadData={...leadData, change_history:newhistory}
    const data2 = await fetchLeadbyId(leadData.lead_id);

    if(insight && "summary" in insight){
      const calltemp={...data2.data.callrecord[insight.index], summary:insight.summary, transcript:insight.transcript}
      const cr=[...data2.data.callrecord]
      cr[insight.index]=calltemp
      finalleadData={...finalleadData,callrecord:cr, updatedAt:new Date()}
    }else{
      finalleadData={...finalleadData,callrecord:"callrecord" in data2.data?data2.data.callrecord:[], updatedAt:new Date()}
    }
   // var crecord=[...leadData.callrecord]
    if(calldata){
      //crecord=leadData.callrecord.map(cr=>cr.caller_id==calldata.caller_id?calldata:cr)
      finalleadData={...finalleadData,callrecord:finalleadData.callrecord.map(cr=>cr.call_id==calldata.call_id?calldata:cr)}
    }
    if(finalleadData.model_beta=="Beta-Initial" && finalleadData.work_complete){
    if(finalleadData.manual_fast_reach && finalleadData.manual_fast_reach_attempted){
      finalleadData.model_beta="Beta"
    }else{
      finalleadData.model_beta="Alpha"
    }
  }
    console.log(finalleadData)
    if(!flag2){
    const updateleadResponse = await updateLeaddata(leadData._id, finalleadData);
    if(!leadData.cust_create){
      leadData.canc_reason=""
      leadData.canc_reason_notes=""
    }
    if (
      updateleadResponse.status == 200 ||
      201 ||
      202 ||
      203 ||
      204 ||
      205 ||
      206 ||
      207
    ) {
      alert(
        "Lead updated for lead with lead id " + updateleadResponse.data.lead_id
      );
      if(flag3){
          window.location = "/custdataentry/"+flag3;
      }else{
          window.location = "/lead/" + updateleadResponse.data.lead_id;
      }
     
    } else {
      alert("Something went wrong. Contact support");
      window.location = "/";
    }
  }
  }else{
    alert("Either budget not selected or customer not found")
  }
  }catch(err){
    console.log(err)
  }
  };

  const createduplicate=async()=>{
    //console.log("ABC")
    let dest= prompt("Enter new destination:");
    let date= prompt("Enter new travel date (YYYY-MM-DD):");
    const temp={...leadData, lead_destination:dest, lead_travel_date:date, quality_upgrade:true}
    console.log(temp)
    delete temp._id
    const data=await addLead(temp)
    console.log(data)
    if (
      data.status == 200 ||
      201 ||
      202 ||
      203 ||
      204 ||
      205 ||
      206 ||
      207
    ) {
      alert(
        "Duplicate lead created with lead id " + data.data.lead_id
      );
      
    } else {
      alert("Something went wrong. Contact support");
      window.location = "/";
    }

  }

  const checkfr=(l)=>{
    if(checkDate(l.createdAt) && !(l.lead_campaign=="" || l.lead_campaign=="Website WA"  || l.lead_campaign=="Meta Chat" || l.lead_campaign=="Meta Ads WA") && !("fast_reach_attempted" in l) && !("fast_reach" in l) &&  !(newgetqualitylead(l)=="Titanium")){
      return true
    }else{
      return false
    }
  }

  const sendnonumbermail=async()=>{
    let from="care@jetovacations.com"
    const data2=await fetchEmployeebyName(leadData.lead_owner)
    let to=[leadData.email_id, data2.data.email]//data.data.primary_email_id,//data2.data.email
    let subject="Need more information for preparing quote - Jeto Vacations"
    
   
    let body=`<p>Hello ${leadData.lead_name}
    <p>Greetings from Jeto Vacations!</p>

    <p>I am sorry that we are unable to connect with you because the phone number received by us (${leadData.mobile_number_text}) seems incorrect.</p>
    <p>Kindly reply with your contact number so that our team can get in touch with you, understand your requirements and share a customized package made as per your requirements</p>
    `
    let receiptmail=gmailSend(from, to, subject, body)
  }

  const handleClose6 = () => {
    setOpen6(false);
  };

  const handleClose5 = () => {
    if(role=="Admin"){
    setOpen5(false);
    }
  };

  const handleClose4 = () => {
    setOpen4(false);
  };

   const handleClose3 = () => {
    setOpen3(false);
  };

  const dialogopen5 = async () => {
    setOpen6(true);

    //console.log(quotelist)
  };

  const shownumber=()=>{
    var temp=""
    if(role=="Admin" || role=="TL" || role=="Support" || role=="Product"){
      alert(temp)
      temp= leadData.mobile_number
    }else{
      if(Attempted){
        temp= leadData.mobile_number
      }
    }
    alert(temp)
    return temp
  }

  const getInsight2=async(url)=>{
    try{
      console.log(url)
      let data = new FormData();
data.append('resource_url', url);
data.append('template_id', '162');

let config = {
  method: 'post',
  maxBodyLength: Infinity,
  url: 'https://api.greylabs.ai/insights/resource/listen',
  headers: { 
    'x-api-key': 'b1ffb90d-c16e-47b9-a810-9719bd46668c', 
    'x-api-secret': 'ZEdTaVZLglasq<ELSeEcC##D#jtsAq ', 
   
  },
  data : data
};

axios.request(config)
.then((response) => {
  console.log(JSON.stringify(response.data));
  setOpen4(true)
  if(response.data.status === 200) {
    console.log(response.data.resource_insight_id)
    let data = JSON.stringify({
      "resource_insight_id": 65646
    });
    
    let config = {
      method: 'post',
      maxBodyLength: Infinity,
      url: 'https://api.greylabs.ai/insights/resource/insights',
      headers: { 
        'x-api-key': 'b1ffb90d-c16e-47b9-a810-9719bd46668c', 
        'x-api-secret': 'ZEdTaVZLglasq<ELSeEcC##D#jtsAq ', 
        'Content-Type': 'application/json'
      },
      data : data
    };
    
    axios.request(config)
    .then((response) => {
      console.log(JSON.stringify(response.data));
      setinsight({transcript:response.data.transcript, summary:response.data.default_prompt_response})
    })
    .catch((error) => {
      console.log(error);
    });
  }else{
    setinsight({transcript:"Insight Id not generated", summary:"Contact Tech support"})
  }
})
.catch((error) => {
  console.log(error);
});
    }catch(err){
  console.log(err)
    }
  }

  
  const getInsight=async(index)=>{
    try{
      console.log(index)
      let t=prompt("Enter time in minutes to process. Usually takes 2 minutes")
      const data=await getinsightviaapi({index:index, lead_id:leadData.lead_id, time:t})
      console.log(data.data)
      if(data.data.details[0].progress==100){
      const temp1=data.data.details[0].transcript.includes("Speaker")?data.data.details[0].transcript.replaceAll("Speaker", "\n\nSpeaker"):""
      const temp2=data.data.details[0].default_prompt_response.includes("Call Summary")?data.data.details[0].default_prompt_response.split("Call Summary"):[]
      const temp3=temp2.length>1?temp2[1].split("Agent Sentiment"):[""]
      setOpen4(true)
      setinsight({transcript:temp1, summary:temp3[0], index:index})

     

      }else{
        alert("Need more time to process. Try again with incresing time")
      }
    }catch(err){
  console.log(err)
    }
  }

  const showInsight = (index)=>{
    setinsight({transcript:leadData.callrecord[index].transcript, summary:leadData.callrecord[index].summary})
    setOpen4(true)
  }

  const getClaudeInsight = async (cr) => {
    try {
      if (!cr.recording_url) {
        alert("No recording URL found for this call.")
        return
      }
      const ok = window.confirm("Transcribe & summarise this call using Claude AI? This can take a couple of minutes.")
      if (!ok) return
      setinsight({ transcript: "Processing... transcribing and summarising the call. Please wait (this can take a few minutes).", summary: "" })
      setOpen4(true)

      // Step 1: start the transcription job.
      const startResp = await startclaudecallinsight({ recording_url: cr.recording_url, call_id: cr.call_id })
      const { jobName, s3Key } = startResp.data

      // Step 2: poll for the result. ~5s interval, up to ~8 minutes.
      const MAX_POLLS = 96
      for (let i = 0; i < MAX_POLLS; i++) {
        await new Promise((r) => setTimeout(r, 5000))
        const statusResp = await getclaudecallinsightstatus({ jobName, s3Key })
        if (statusResp.data.status === "completed") {
          setinsight({ transcript: statusResp.data.transcript, summary: statusResp.data.summary })
          return
        }
        // else still processing — keep waiting.
      }
      setinsight({ transcript: "Transcription is taking longer than expected. Please try again in a minute.", summary: "" })
    } catch (err) {
      console.log(err)
      const msg = err.response && err.response.data && err.response.data.error ? err.response.data.error : "Something went wrong while generating the AI insight."
      setinsight({ transcript: msg, summary: "" })
      setOpen4(true)
    }
  }

  const verifycall=()=>{
    let x=window.confirm("SS team already verified and took requirements. Do you still need to call?")
    if(x){
      apicall()
    }
  }

  const qualityopen=(cr)=>{
    setOpen3(true)
    setcalldata(cr)
  }

  const sendwa=()=>{
    setleadData({...leadData, fast_reach_whatsapp:true})
    var textarr=[
      "Greetings from Jeto Vacations!%0a%0aThank you for placing your enquiry for "+leadData.lead_destination+". We were trying to connect with you to understand your preferences for your upcoming vacation. Kindly let us know a good time to connect",

      "Greetings from Jeto Vacations!%0a%0aThank you for your enquiry regarding "+leadData.lead_destination+". We attempted to reach you to discuss your travel preferences and assist you better with your vacation plans. Please let us know a convenient time to connect.",

      "Hello from Jeto Vacations!%0a%0aWe are delighted to assist you with your upcoming "+leadData.lead_destination+" vacation. Our team attempted to connect with you to understand your preferences and recommend the best packages. Please reply with a suitable time for a quick call.",

      "Greetings from Jeto Vacations!%0a%0aThank you for reaching out regarding your "+leadData.lead_destination+" holiday plans. Our travel expert tried contacting you to discuss suitable options and ongoing offers. Kindly reply with a preferred time to connect.",

      "Hello from Jeto Vacations!%0a%0aYour enquiry for "+leadData.lead_destination+" has been received successfully. We would love to assist you with the best travel deals and customized holiday packages. Please reply with a convenient time for our team to connect with you.",

      "Greetings from Jeto Vacations!%0a%0aThank you for your interest in traveling to "+leadData.lead_destination+". We tried getting in touch to understand your requirements and suggest the best travel plans for you. Kindly reply with a suitable time to connect.",

      "Hello from Jeto Vacations!%0a%0aWe received your enquiry for "+leadData.lead_destination+" and would love to help you plan a memorable vacation. Our team tried contacting you to discuss suitable package options. Please reply with your preferred time for a quick discussion.",

      "Greetings from Jeto Vacations!%0a%0aThank you for considering us for your "+leadData.lead_destination+" trip. We tried reaching out to assist you with exciting holiday packages and exclusive offers. Kindly respond with a convenient time to connect with our team.",

      "Greetings from Jeto Vacations!%0a%0aWe are excited to help you plan your upcoming "+leadData.lead_destination+" vacation. Our team tried contacting you to discuss the best offers and experiences for your trip. Kindly reply with your preferred time for a quick call.",

      "Hello from Jeto Vacations!%0a%0aThank you for enquiring about "+leadData.lead_destination+". We tried reaching you to understand your travel preferences and share the best package options available for your trip. Please reply with a convenient time to connect with our team.",

      "Greetings from Jeto Vacations!%0a%0aThank you for your interest in our "+leadData.lead_destination+" holiday packages. We would love to help you plan the perfect vacation with the best deals and customized options. Kindly reply with a suitable time to connect, and our travel expert will assist you further.",
    ]
    const randomInt = Math.floor(Math.random() * 11);
    var win = window.open(
        `https://wa.me/91${leadData.mobile_number}?text=${textarr[randomInt]}`,
        "_blank"
      );
  }

  const createcust=()=>{
    //if employee record does not have flag then allow else check if either call is attempted or thereis existing callrecord
    if(!createcustflag){
    window.open("/custdataentry","_blank")
    }else{
      if(Attempted || spcalled){
        window.open("/custdataentry","_blank")
      }else{
      alert("No call record found")
      } 
    }
  }
  //console.log(leadData)
  //console.log(callcriteria)

  return (
    <div>
    {cuser && role?(
    <Paper variant="outlined" className={classes.paper} elevation={10}>

    <Dialog
        fullWidth
        maxWidth="xl"
        open={Open6}
        onClose={handleClose6}
      >
        <Table>
        <TableRow>
              <TableCell>Agent</TableCell>
              <TableCell>Time</TableCell>
              <TableCell>Status</TableCell>
              <TableCell>Duration</TableCell>
              <TableCell>Recording</TableCell>
              <TableCell>Cause</TableCell>
              <TableCell>Call Id</TableCell>
              <TableCell>Quality</TableCell>
              {/* <TableCell>Insight</TableCell> */}
          </TableRow>
        {"callrecord" in leadData && removeDuplicatesmulti2(leadData.callrecord,"answered_agent_name", "duration", "start_stamp").map(cr=>
          <TableRow>
          <TableCell>
                {cr.answered_agent_name}
              </TableCell>
          <TableCell>
                {cr.start_stamp}
              </TableCell>
              <TableCell>
                {cr.call_status} 
              </TableCell>
              <TableCell>
              {cr.call_status=="answered"?cr.outbound_sec:cr.duration}
              </TableCell>
              <TableCell>
              <audio src={cr.recording_url} controls>
              Your browser does not support the audio element.
              </audio>
               
              </TableCell>
              <TableCell>
                {cr.hangup_cause}
              </TableCell>
              <TableCell>
                {cr.call_id}
              </TableCell>
              <TableCell>
              {cr.call_status=="answered"?(
                  <Button
            onClick={()=>qualityopen(cr)}
            variant="contained"
            target="_blank"
            color="primary"
            className={classes.smallbutton2}
          >
            Quality
          </Button>
             ):("")}
              </TableCell>
              <TableCell>
              {role=="Admin" || role=="Manager" || role=="Product"?(
                <div>
                {/* <Button
              onClick={()=>getInsight(leadData.callrecord.indexOf(cr))}
            variant="contained"
            target="_blank"
            color="primary"
            className={classes.smallbutton2}
          >
            Go
          </Button> */}
          <Button
              onClick={()=>getClaudeInsight(cr)}
            variant="contained"
            target="_blank"
            color="secondary"
            className={classes.smallbutton2}
          >
            AI Insight
          </Button>
          {"summary" in cr?(
            {/* <Button
              onClick={()=>showInsight(leadData.callrecord.indexOf(cr))}
            variant="contained"
            target="_blank"
            color="primary"
            className={classes.smallbutton2}
          >
            Insight
          </Button> */}
          ):("")}
          </div>
              ):("")}
              
              </TableCell>
          </TableRow>
        )}
          
        </Table>
      </Dialog>

      <Dialog
        fullWidth
        maxWidth="xl"
        open={Open5}
        onClose={handleClose5}
      >
      <FormControl style={{minWidth: 480, marginTop: 16, marginRight: 32, marginLeft: 8}}>
            <InputLabel id="Destination">Destination</InputLabel>
                <Select displayEmpty className={classes.textField} InputLabelProps={{ shrink: true }} labelId="Destination" value={leadfilterData.destination} onChange={(e)=> setleadfilterData({...leadfilterData, destination: e.target.value})}>
                <MenuItem value="Bali">Bali</MenuItem>
                {dest.map((dest) => {
                return <MenuItem value={dest}>{dest}</MenuItem>;
              })}
                    
                    
                
                </Select>
                </FormControl>
        <Button
            href={leadfilterData.destination=="Sri Lanka"?("/knowledge/"+leadfilterData.destination.split(" ").join("")):"/knowledge/"+leadfilterData.destination}
            variant="contained"
            target="_blank"
            color="inherit"
            className={classes.smallbutton2}
          >
            Go
          </Button>
      <h3 className={classes.headtext}> Name: {leadData.lead_name} || Destination: {leadData.lead_destination} || Date: {leadData.lead_travel_date} || Pax: {leadData.lead_pax} || Source: {leadData.lead_platform}|| Departure: {leadData.lead_source_airport}</h3>
      {"lead_other_quotes" in leadData && leadData.lead_other_quotes=="Yes, I am already comparing multiple quotes"?(<BlinkingText variant="h3">Customer mentioned that he is comparing other quotes</BlinkingText>):("")}
      <hr></hr>
      <h4 className={classes.bodytext}>Description:</h4>
      <h4 className={classes.bodytext}>{leadData.lead_notes}</h4>
      <hr></hr>
      <h2 className={classes.headtext}>Confirm the following details:</h2>
      <h4 className={classes.bodytext}>Destination (Fixed/Flexible-what does it depend on)</h4>
      <h4 className={classes.bodytext}>Date of travel (Fixed or Flexible- if flexible whats the range and what does it depend on)</h4>
      <h4 className={classes.bodytext}>Number of pax (Adult/Child-age of child)</h4>
      <h4 className={classes.bodytext}>Budget (With or without flight)</h4>
      <h4 className={classes.bodytext}>Duration (Fixed/Flexible-what does it depend on)</h4>
      <h4 className={classes.bodytext}>Confirm if all pax have passports</h4>
      <br></br>
      <h2 className={classes.headtext}>Explain Destination:</h2>
      <h4 className={classes.bodytext}>Explain as per his requirement mentioned above</h4>
      <h4 className={classes.bodytext}>Guide about destination as per customer type and reason for visit</h4>
      <br></br>
      <h2 className={classes.headtext}>Identify intent:</h2>
      <h4 className={classes.bodytext}>Why are they taking this vacation?</h4>
      <h4 className={classes.bodytext}>When are they planning to book?</h4>
      <h4 className={classes.bodytext}>Do they have any specific requirement?</h4>
      <h4 className={classes.bodytext2}>Do all passengers have their passports ready?</h4>
      <h4 className={classes.bodytext}>Did they do any research on the destination?</h4>
      <h4 className={classes.bodytext}>Did they book their flights?</h4>
      <h4 className={classes.bodytext2}>Did they receive quote from other agencies?</h4>
      <br></br>
      <TextField variant="outlined"  label="Notes" InputLabelProps={{ shrink: true }} value={leadData.lead_cust_notes} className={classes.textArea2}  multiline rows={4} onChange={(e) => setleadData({ ...leadData, lead_cust_notes: e.target.value })}/>
      <br></br>
      <h2 className={classes.headtext}>Questions for Rapport:</h2>
      <h4 className={classes.bodytext}>Where are you from?</h4>
      <h4 className={classes.bodytext}>Where do you live?</h4>
      <h4 className={classes.bodytext}>Where have you visited in the past?</h4>
      <h4 className={classes.bodytext}>Why are you travelling?</h4>
      <h4 className={classes.bodytext}>Why travel now?</h4>
      <h4 className={classes.bodytext}>Why did you choose your destination?</h4>
      <h4 className={classes.bodytext}>What things do you plan to do at the destination?</h4>
      <h4 className={classes.bodytext}>Did you talk to any other travel agent?</h4>
      <h4 className={classes.bodytext}>Who are your fellow travellers?</h4>
      <br></br>
      <FormControl
            style={{
              minWidth: 480,
              marginTop: 16,
              marginRight: 32,
              marginLeft: 8,
            }}
          >
            <InputLabel id="budget">Budget</InputLabel>
            <Select
             
              className={classes.textField}
              labelId="budget"
              required
              value={leadData.lead_budget}
              onChange={(e) =>
                setleadData({ ...leadData, lead_budget: e.target.value })
              }
            >
            <MenuItem value="">Clear</MenuItem>
            <MenuItem value="Less than 10k per person (without flight)">Less than 10k per person (without flight)</MenuItem>
            <MenuItem value="10k-20k per person (without flight)">10k-20k per person (without flight)</MenuItem>
            <MenuItem value="20k-30k per person (without flight)">20k-30k per person (without flight)</MenuItem>
            <MenuItem value="30k-40k per person (without flight)">30k-40k per person (without flight)</MenuItem>
            <MenuItem value="40k-50k per person (without flight)">40k-50k per person (without flight)</MenuItem>
            <MenuItem value="50k-60k per person (without flight)">50k-60k per person (without flight)</MenuItem>
            <MenuItem value="60k-80k per person (without flight)">60k-80k per person (without flight)</MenuItem>
            <MenuItem value="80k-100k per person (without flight)">80k-100k per person (without flight)</MenuItem>
            <MenuItem value="100k+ per person (without flight)">100k+ per person (without flight)</MenuItem>
            <MenuItem value="Less than 30k (with flight)">Less than 30k (with flight)</MenuItem>
            <MenuItem value="30k-40k per person (with flight)">30k-40k per person (with flight)</MenuItem>
            <MenuItem value="40k-50k per person (with flight)">40k-50k per person (with flight)</MenuItem>
            <MenuItem value="50k-60k per person (with flight)">50k-60k per person (with flight)</MenuItem>
            <MenuItem value="60k-70k per person (with flight)">60k-70k per person (with flight)</MenuItem>
            <MenuItem value="70k-80k per person (with flight)">70k-80k per person (with flight)</MenuItem>
            <MenuItem value="80k-90k per person (with flight)">80k-90k per person (with flight)</MenuItem>
            <MenuItem value="90k-100k per person (with flight)">90k-100k per person (with flight)</MenuItem>
            <MenuItem value="100k-125k per person (with flight)">100k-125k per person (with flight)</MenuItem>
            <MenuItem value="125k-150k per person (with flight)">125k-150k per person (with flight)</MenuItem>
            <MenuItem value="150k-175k per person (with flight)">150k-175k per person (with flight)</MenuItem>
            <MenuItem value="175k-200k per person (with flight)">175k-200k per person (with flight)</MenuItem>
            <MenuItem value="200k+ per person (with flight)">200k+ per person (with flight)</MenuItem>
            <MenuItem value="Unwilling to disclose">Unwilling to disclose</MenuItem>
            <MenuItem value="Unable to confirm">Unable to confirm</MenuItem>
            <MenuItem value="Forgot to ask">Forgot to ask</MenuItem>
            </Select>
          </FormControl>
      {role=="Sales Support" || role=="Admin" || role=="TL" || role=="Marketing" || role=="Manager" ?(
        <FormControl
            style={{
              minWidth: 480,
              marginTop: 16,
              marginRight: 32,
              marginLeft: 8,
            }}
          >
            <InputLabel id="support">Support</InputLabel>
            <Select
              disabled={(role == "Admin" || role=="Sales Support" )? 0 : 1}
              className={classes.textField}
              labelId="support"
              required
              value={leadData.lead_owner_support}
              onChange={(e) =>
                setleadData({ ...leadData, lead_owner_support: e.target.value })
              }
            >
            <MenuItem value="Amit">Amit</MenuItem>
            <MenuItem value="Abhishek">Abhishek</MenuItem>
              {emp2.map((emp) => {
                return <MenuItem value={emp}>{emp}</MenuItem>;
              })}
            </Select>
          </FormControl>
      ):("")}
      <FormGroup row className={classes.formgroup}>
      {role?(
          <FormControlLabel
            disabled={role && (role=="Sales" || (role=="Sales Support" && oldstatus && "work_complete_date" in leadData && leadData.work_complete_date && new Date(leadData.work_complete_date).getTime()<new Date(DateCalc(0)).getTime()))?1:0}
            control={<Checkbox color="primary" />}
            checked={leadData.work_complete}
            label="Work Done?"
            onChange={(e) =>
              setleadData({ ...leadData, work_complete: e.target.checked, work_complete_date:e.target.checked?new Date():null })
            }
          />
        ):("")}
          {role && (!(role=="Sales" || role=="Sales Support" || role=="Support"|| role=="Operations") || ((newgetqualitylead(leadData)=="Iron" || newgetqualitylead(leadData)=="Copper" || newgetqualitylead(leadData)=="Silver") && role=="Sales Support"))?(
            <FormControlLabel
            disabled={role=="Sales"?(callcriteria?0:1):(role=="Sales Support"?(callcriteria2?0:1):0)}
            control={<Checkbox color="primary" />}
            checked={leadData.cust_create}
            label="Create Customer?"
            onChange={(e) =>
              setleadData({ ...leadData, cust_create: e.target.checked })
            }
          />
          ):(
             <FormControlLabel
            control={<Checkbox color="primary" />}
            checked={leadData.cust_create}
            label="Create Customer?"
            disabled
          />
          )}
          
          <FormControlLabel
            control={<Checkbox color="secondary" />}
            checked={leadData.potential}
            label="Potential?"
            onChange={(e) =>
              setleadData({ ...leadData, potential: e.target.checked })
            }
          />
          {(role=="Sales Support" || role=="Admin" || cuser=="Tarun")  && !("work_complete" in leadData && leadData.work_complete) ?(
            <div>
            {(newgetqualitylead(leadData)=="Iron" || newgetqualitylead(leadData)=="Copper" || newgetqualitylead(leadData)=="Silver" || newgetqualitylead(leadData)=="Titanium")?(
              <FormControlLabel
            control={<Checkbox color="secondary" />}
            checked={leadData.quality_upgrade}
            label="Upgrade"
            onChange={(e) =>
              setleadData({ ...leadData, quality_upgrade: e.target.checked })
            }
          />
            ):(
              <FormControlLabel
            control={<Checkbox color="secondary" />}
            checked={leadData.back_to_sales}
            label="Send To Sales"
            onChange={(e) =>
              setleadData({ ...leadData, back_to_sales: e.target.checked })
            }
          />
            )}
            
          <div>
        {"callrecord" in leadData && leadData.callrecord.length>0?(
            <div>
            <FormControlLabel
            disabled={role=="Admin"?0:(role=="Sales Support"?(leadData.manual_fast_reach_attempted?0:1):1)}
            control={<Checkbox color="primary" />}
            checked={leadData.manual_fast_reach}
            label="Fast Reach Success"
            onChange={(e) =>
              setleadData({ ...leadData, manual_fast_reach: e.target.checked, quality_upgrade: (newgetqualitylead(leadData)=="Iron" || newgetqualitylead(leadData)=="Copper" || newgetqualitylead(leadData)=="Silver")?e.target.checked:false })
            }
           
          />
          
          <FormControlLabel
            disabled={(role=="Sales Support" && checkfr(leadData)) || role=="Admin"?0:1}
            control={<Checkbox color="primary" />}
            checked={leadData.manual_fast_reach_attempted}
            label="Fast Reach Attempted"
            onChange={(e) =>
              setleadData({ ...leadData, manual_fast_reach_attempted: e.target.checked, manual_fast_reach_attempted_time:new Date() })
            }
          />
           
            <FormControlLabel
            disabled={role=="Admin"?0:(role=="Sales Support"?(leadData.manual_fast_reach_attempted?0:1):1)}
            control={<Checkbox color="primary" />}
            checked={leadData.manual_fast_reach_failed}
            label="Fast Reach Failed"
            onChange={(e) =>
              setleadData({ ...leadData, manual_fast_reach_failed: e.target.checked })
            }
          />
          </div>
          ):("")}
          </div>
        
          <br></br>
          <h2 className={classes.headtext}>If you are upgrading quality, do not mark leads as Work Done</h2>
          </div>
        ):(<div>
          {
            role=="Admin"?(<div>
              <FormControlLabel
            control={<Checkbox color="secondary" />}
            checked={leadData.back_to_sales}
            label="Send To Sales"
            disabled
          />
           <FormControlLabel
            disabled
            control={<Checkbox color="primary" />}
            checked={leadData.manual_fast_reach}
            label="Fast Reach"
           
           
          />
            <FormControlLabel
            disabled
            control={<Checkbox color="primary" />}
            checked={leadData.manual_fast_reach_attempted}
            label="Fast Reach Attempted"
            
          />

            <FormControlLabel
            disabled
            control={<Checkbox color="primary" />}
            checked={leadData.manual_fast_reach_failed}
            label="Fast Reach Failed"
            
          />
            </div>):("")
          }
        </div>)}
          
        </FormGroup>
      
        
        <FormGroup row className={classes.formgroup}>
          {leadData.cust_create == false ? (
            <FormControl
              style={{
                minWidth: 480,
                marginTop: 16,
                marginRight: 32,
                marginLeft: 8,
              }}
            >
              <InputLabel id="reason">Customer not creation reason</InputLabel>
              <Select
                className={classes.textField}
                labelId="reason"
                value={leadData.canc_reason}
                onChange={(e) =>
                  setleadData({ ...leadData, canc_reason: e.target.value })
                }
              >
                <MenuItem value={"Wrong number"}>Wrong number</MenuItem>
                <MenuItem value={"Number unreachable"}>
                  Number unreachable
                </MenuItem>
                <MenuItem value={"Cancelled by marketing"}>Cancelled by marketing</MenuItem>
                <MenuItem value={"Duplicate Lead"}>Duplicate Lead</MenuItem>
                <MenuItem value={"Already Booked"}>Already Booked</MenuItem>
                <MenuItem value={"Denied placing lead"}>Denied placing lead</MenuItem>
                <MenuItem value={"Not serving destination"}>Not serving destination</MenuItem>
                <MenuItem value={"Budget Problem"}>Budget Problem</MenuItem>
                <MenuItem value={"Solo Traveller"}>Solo Traveller</MenuItem>
                <MenuItem value={"Others"}>Others</MenuItem>
              </Select>
            </FormControl>
          ) : (
            ""
          )}
          {/* {leadData.trip_create == false ?
                <FormControl style={{minWidth: 480, marginTop: 16, marginRight: 32, marginLeft: 8}}>
            <InputLabel id="reason">Trip not creation reason</InputLabel>
                <Select className={classes.textField} labelId="reason" value={leadData.trip_canc_reason} onChange={(e)=> setleadData({...leadData, trip_canc_reason: e.target.value})}>
                    <MenuItem value={"Low Budget"}>Low Budget</MenuItem>
                    <MenuItem value={"Looking for Info only"}>Looking for Info only</MenuItem> 
                    <MenuItem value={"Not planning any trip"}>Not planning any trip</MenuItem> 
                    <MenuItem value={"Lead placed by mistake"}>Lead placed by mistake</MenuItem> 
                    <MenuItem value={"Destination not served"}>Destination not served</MenuItem> 
                    <MenuItem value={"Others"}>Others</MenuItem>   
                
                </Select>
                </FormControl>
                : ""} */}
        </FormGroup>

        {leadData.canc_reason == "Others" && leadData.cust_create == false ? (
          <FormGroup row className={classes.formgroup}>
            <TextField
              variant="outlined"
              label="Customer not creation reason"
              value={leadData.canc_reason_notes}
              className={classes.textArea}
              fullWidth
              multiline
              rows={2}
              onChange={(e) =>
                setleadData({ ...leadData, canc_reason_notes: e.target.value })
              }
            />
          </FormGroup>
        ) : (
          ""
        )}
        <FormGroup row className={classes.formgroup}>
          <h2 align="center">
            Once a lead is marked as Done, it will not be visible anymore
          </h2>
        </FormGroup>
       
          <FormGroup row className={classes.formgroup}>
          <Button
            variant="contained"
            color="primary"
            onClick={handleSubmit}
            className={classes.button}
          >
            Save
          </Button>
          <Button
            href="/home"
            variant="contained"
            color="secondary"
            className={classes.button}
          >
            Cancel
          </Button>
          
          {leadData?.cust_create ? (
            <Button
              // href="/custdataentry"
              // target="_blank"
              onClick={createcust}
              variant="contained"
              color="inherit"
              className={classes.button}
            >
              Create Customer
            </Button>
          ) : (
            ""
          )}
          {role=="Sales Support" || role=="Manager" || role=="Admin" ? (
          <Button
            onClick={createduplicate}
            variant="contained"
            color="secondary"
            className={classes.button}
          >
            Duplicate
          </Button>
          ):("")}
        </FormGroup>
    
        
      </Dialog>

      <Dialog
        fullWidth
        maxWidth="xl"
        open={Open4}
        onClose={handleClose4}
      >

        {insight?(<div style={{padding: "0 16px"}}>
          <h3>&nbsp;&nbsp;&nbsp;Summary:</h3>
          <p style={{whiteSpace: "pre-wrap"}}>{insight.summary}</p>
          <br></br>
          <hr></hr>
          <br></br>
          <h3>&nbsp;&nbsp;&nbsp;Transcript:</h3>
          <br></br>
          <p style={{whiteSpace: "pre-wrap"}}>{insight.transcript}</p>
          </div>
        ):("")}
        <Button
            variant="contained"
            color="primary"
            onClick={handleSubmit}
            className={classes.button}
          >
            Save
          </Button>
      </Dialog>

      <Dialog
        fullWidth
        maxWidth="xl"
        open={Open3}
        onClose={handleClose3}
      >
      <FormGroup row className={classes.formgroup}>
         <FormControl
                   style={{
                     minWidth: 240,
                     marginTop: 16,
                     marginRight: 32,
                     marginLeft: 8,
                   }}
                 >
                   <InputLabel id="opening">Call Type</InputLabel>
                   <Select
                     displayEmpty
                     classname={classes.textField2}
                     labelId="opening"
                     disabled={role=="Admin" || role=="Manager"?0:1}
                     value={calldata.call_type}
                     onChange={(e) =>
                       setcalldata({ ...calldata, call_type: e.target.value, audit_date:new Date() })
                     }
                   >
                    <MenuItem value={"First Call"}>First Call</MenuItem>
                    
                    
                   </Select>
                 </FormControl>
                 <FormControl
                   style={{
                     minWidth: 240,
                     marginTop: 16,
                     marginRight: 32,
                     marginLeft: 8,
                   }}
                 >
                   <InputLabel id="basic info">Basic Info Verification</InputLabel>
                   <Select
                     displayEmpty
                     classname={classes.textField2}
                     labelId="basic info"
                     disabled={role=="Admin" || role=="Manager"?0:1}
                     value={calldata.basic_information}
                     onChange={(e) =>
                       setcalldata({ ...calldata, basic_information: e.target.value })
                     }
                   >
                   <MenuItem value={null}>Clear</MenuItem>
                      <MenuItem value={0}>0</MenuItem>
                     <MenuItem value={1}>1</MenuItem>
                     <MenuItem value={2}>2</MenuItem>
                     <MenuItem value={3}>3</MenuItem>
                     <MenuItem value={4}>4</MenuItem>
                     <MenuItem value={5}>5</MenuItem>
                     <MenuItem value={6}>6</MenuItem>
                     <MenuItem value={7}>7</MenuItem>
                     <MenuItem value={8}>8</MenuItem>
                     <MenuItem value={9}>9</MenuItem>
                     <MenuItem value={10}>10</MenuItem>
                    
                   </Select>
                 </FormControl>
              </FormGroup>
              <FormGroup row className={classes.formgroup}>

              <FormControl
                   style={{
                     minWidth: 240,
                     marginTop: 16,
                     marginRight: 32,
                     marginLeft: 8,
                   }}
                 >
                   <InputLabel id="opening">Opening Script</InputLabel>
                   <Select
                     displayEmpty
                     classname={classes.textField2}
                     labelId="opening"
                     disabled={role=="Admin" || role=="Manager"?0:1}
                     value={calldata.opening_script}
                     onChange={(e) =>
                       setcalldata({ ...calldata, opening_script: e.target.value })
                     }
                   >
                     <MenuItem value={null}>Clear</MenuItem>
                    <MenuItem value={0}>0</MenuItem>
                     <MenuItem value={1}>1</MenuItem>
                     <MenuItem value={2}>2</MenuItem>
                     <MenuItem value={3}>3</MenuItem>
                     <MenuItem value={4}>4</MenuItem>
                   </Select>
                 </FormControl> 
                  <FormControl
                   style={{
                     minWidth: 240,
                     marginTop: 16,
                     marginRight: 32,
                     marginLeft: 8,
                   }}
                 >
                   <InputLabel id="closing">Closing Script</InputLabel>
                   <Select
                     displayEmpty
                     classname={classes.textField2}
                     labelId="closing"
                     disabled={role=="Admin" || role=="Manager"?0:1}
                     value={calldata.closing_script}
                     onChange={(e) =>
                       setcalldata({ ...calldata, closing_script: e.target.value })
                     }
                   >
                     <MenuItem value={null}>Clear</MenuItem>
                    <MenuItem value={0}>0</MenuItem>
                     <MenuItem value={1}>1</MenuItem>
                     <MenuItem value={2}>2</MenuItem>
                     <MenuItem value={3}>3</MenuItem>
                    
                   </Select>
                 </FormControl> 
                  <FormControl
                   style={{
                     minWidth: 240,
                     marginTop: 16,
                     marginRight: 32,
                     marginLeft: 8,
                   }}
                 >
                   <InputLabel id="hold">Hold Script</InputLabel>
                   <Select
                     displayEmpty
                     classname={classes.textField2}
                     labelId="hold"
                     disabled={role=="Admin" || role=="Manager"?0:1}
                     value={calldata.hold_script}
                     onChange={(e) =>
                       setcalldata({ ...calldata, hold_script: e.target.value })
                     }
                   >
                     <MenuItem value={null}>Clear</MenuItem>
                    <MenuItem value={0}>0</MenuItem>
                     <MenuItem value={1}>1</MenuItem>
                     <MenuItem value={2}>2</MenuItem>
                     <MenuItem value={3}>3</MenuItem>
               
                   </Select>
                 </FormControl> 
                 </FormGroup>
                    <hr></hr>
                    <br></br>
                  <FormGroup row className={classes.formgroup}>

              <FormControl
                   style={{
                     minWidth: 240,
                     marginTop: 16,
                     marginRight: 32,
                     marginLeft: 8,
                   }}
                 >
                   <InputLabel id="Interruption">Interruption</InputLabel>
                   <Select
                     displayEmpty
                     classname={classes.textField2}
                     labelId="Interruption"
                     disabled={role=="Admin" || role=="Manager"?0:1}
                     value={calldata.interruption}
                     onChange={(e) =>
                       setcalldata({ ...calldata, interruption: e.target.value })
                     }
                   >
                     <MenuItem value={null}>Clear</MenuItem>
                    <MenuItem value={0}>0</MenuItem>
                     <MenuItem value={1}>1</MenuItem>
                     <MenuItem value={2}>2</MenuItem>
                     <MenuItem value={3}>3</MenuItem>
                  
                   </Select>
                 </FormControl> 
                  <FormControl
                   style={{
                     minWidth: 240,
                     marginTop: 16,
                     marginRight: 32,
                     marginLeft: 8,
                   }}
                 >
                   <InputLabel id="ros">Rate of Speech</InputLabel>
                   <Select
                     displayEmpty
                     classname={classes.textField2}
                     labelId="ros"
                     disabled={role=="Admin" || role=="Manager"?0:1}
                     value={calldata.rate_of_speech}
                     onChange={(e) =>
                       setcalldata({ ...calldata, rate_of_speech: e.target.value })
                     }
                   >
                     <MenuItem value={null}>Clear</MenuItem>
                    <MenuItem value={0}>0</MenuItem>
                     <MenuItem value={1}>1</MenuItem>
                     <MenuItem value={2}>2</MenuItem>
                    
                    
                   </Select>
                 </FormControl> 
                  <FormControl
                   style={{
                     minWidth: 240,
                     marginTop: 16,
                     marginRight: 32,
                     marginLeft: 8,
                   }}
                 >
                   <InputLabel id="personalization">Personalization</InputLabel>
                   <Select
                     displayEmpty
                     classname={classes.textField2}
                     labelId="personalization"
                     disabled={role=="Admin" || role=="Manager"?0:1}
                     value={calldata.personalization}
                     onChange={(e) =>
                       setcalldata({ ...calldata, personalization: e.target.value })
                     }
                   >
                     <MenuItem value={null}>Clear</MenuItem>
                    <MenuItem value={0}>0</MenuItem>
                     <MenuItem value={1}>1</MenuItem>
                     <MenuItem value={2}>2</MenuItem>
                     <MenuItem value={3}>3</MenuItem>
               
                   </Select>
                 </FormControl> 
                 </FormGroup>
                  <FormGroup row className={classes.formgroup}>

              <FormControl
                   style={{
                     minWidth: 240,
                     marginTop: 16,
                     marginRight: 32,
                     marginLeft: 8,
                   }}
                 >
                   <InputLabel id="psgu">Pronunciation/Spelling/Grammar/Understandability</InputLabel>
                   <Select
                     displayEmpty
                     classname={classes.textField2}
                     labelId="psgu"
                     disabled={role=="Admin" || role=="Manager"?0:1}
                     value={calldata.tone}
                     onChange={(e) =>
                       setcalldata({ ...calldata, tone: e.target.value })
                     }
                   >
                     <MenuItem value={null}>Clear</MenuItem>
                    <MenuItem value={0}>0</MenuItem>
                     <MenuItem value={1}>1</MenuItem>
                     <MenuItem value={2}>2</MenuItem>
                     <MenuItem value={3}>3</MenuItem>
                  
                   </Select>
                 </FormControl> 
                  <FormControl
                   style={{
                     minWidth: 240,
                     marginTop: 16,
                     marginRight: 32,
                     marginLeft: 8,
                   }}
                 >
                   <InputLabel id="tone">Tone</InputLabel>
                   <Select
                     displayEmpty
                     classname={classes.textField2}
                     labelId="tone"
                     disabled={role=="Admin" || role=="Manager"?0:1}
                     value={calldata.language}
                     onChange={(e) =>
                       setcalldata({ ...calldata, language: e.target.value })
                     }
                   >
                     <MenuItem value={null}>Clear</MenuItem>
                    <MenuItem value={0}>0</MenuItem>
                     <MenuItem value={1}>1</MenuItem>
                     <MenuItem value={2}>2</MenuItem>
                     <MenuItem value={3}>3</MenuItem>
                  
                   </Select>
                 </FormControl> 
                  <FormControl
                   style={{
                     minWidth: 240,
                     marginTop: 16,
                     marginRight: 32,
                     marginLeft: 8,
                   }}
                 >
                   <InputLabel id="hold">Fumbling/Fillers/Slangs/Dead Air</InputLabel>
                   <Select
                     displayEmpty
                     classname={classes.textField2}
                     labelId="hold"
                     disabled={role=="Admin" || role=="Manager"?0:1}
                     value={calldata.fillers}
                     onChange={(e) =>
                       setcalldata({ ...calldata, fillers: e.target.value })
                     }
                   >
                     <MenuItem value={null}>Clear</MenuItem>
                    <MenuItem value={0}>0</MenuItem>
                     <MenuItem value={1}>1</MenuItem>
                     <MenuItem value={2}>2</MenuItem>
                     <MenuItem value={3}>3</MenuItem>
                     <MenuItem value={4}>4</MenuItem>
                     <MenuItem value={5}>5</MenuItem>
                     <MenuItem value={6}>6</MenuItem>
               
                   </Select>
                 </FormControl> 
                 </FormGroup>
                 <hr></hr>
                  <br></br>
                   <FormGroup row className={classes.formgroup}>

              <FormControl
                   style={{
                     minWidth: 240,
                     marginTop: 16,
                     marginRight: 32,
                     marginLeft: 8,
                   }}
                 >
                   <InputLabel id="psgu">Active Listening/Attentive on Call/Repetition Same Query</InputLabel>
                   <Select
                     displayEmpty
                     classname={classes.textField2}
                     labelId="psgu"
                     disabled={role=="Admin" || role=="Manager"?0:1}
                     value={calldata.active_listening}
                     onChange={(e) =>
                       setcalldata({ ...calldata, active_listening: e.target.value })
                     }
                   >
                     <MenuItem value={null}>Clear</MenuItem>
                    <MenuItem value={0}>0</MenuItem>
                     <MenuItem value={1}>1</MenuItem>
                     <MenuItem value={2}>2</MenuItem>
                     <MenuItem value={3}>3</MenuItem>
                     <MenuItem value={4}>4</MenuItem>
                     <MenuItem value={5}>5</MenuItem>
                     <MenuItem value={6}>6</MenuItem>
                     <MenuItem value={7}>7</MenuItem>
                  
                   </Select>
                 </FormControl> 
                  <FormControl
                   style={{
                     minWidth: 240,
                     marginTop: 16,
                     marginRight: 32,
                     marginLeft: 8,
                   }}
                 >
                   <InputLabel id="rapport">Rapport Building</InputLabel>
                   <Select
                     displayEmpty
                     classname={classes.textField2}
                     labelId="rapport"
                     disabled={role=="Admin" || role=="Manager"?0:1}
                     value={calldata.rapport}
                     onChange={(e) =>
                       setcalldata({ ...calldata, rapport: e.target.value })
                     }
                   >
                     <MenuItem value={null}>Clear</MenuItem>
                    <MenuItem value={0}>0</MenuItem>
                     <MenuItem value={1}>1</MenuItem>
                     <MenuItem value={2}>2</MenuItem>
                     <MenuItem value={3}>3</MenuItem>
                     <MenuItem value={4}>4</MenuItem>
                     <MenuItem value={5}>5</MenuItem>
                     <MenuItem value={6}>6</MenuItem>
                     <MenuItem value={7}>7</MenuItem>
                     <MenuItem value={8}>8</MenuItem>
                     <MenuItem value={9}>9</MenuItem>
                     <MenuItem value={10}>10</MenuItem>
                     <MenuItem value={11}>11</MenuItem>
                     <MenuItem value={12}>12</MenuItem>
                     <MenuItem value={13}>13</MenuItem>
                     <MenuItem value={14}>14</MenuItem>
                     <MenuItem value={15}>15</MenuItem>
                     <MenuItem value={16}>16</MenuItem>
                     <MenuItem value={17}>17</MenuItem>
                  
                   </Select>
                 </FormControl> 
                  <FormControl
                   style={{
                     minWidth: 240,
                     marginTop: 16,
                     marginRight: 32,
                     marginLeft: 8,
                   }}
                 >
                   <InputLabel id="empathy">Acknowledgement, Confirmation, Empathy</InputLabel>
                   <Select
                     displayEmpty
                     classname={classes.textField2}
                     labelId="empathy"
                     disabled={role=="Admin" || role=="Manager"?0:1}
                     value={calldata.empathy}
                     onChange={(e) =>
                       setcalldata({ ...calldata, empathy: e.target.value })
                     }
                   >
                     <MenuItem value={null}>Clear</MenuItem>
                    <MenuItem value={0}>0</MenuItem>
                     <MenuItem value={1}>1</MenuItem>
                     <MenuItem value={2}>2</MenuItem>
                     <MenuItem value={3}>3</MenuItem>
                     <MenuItem value={4}>4</MenuItem>
                     <MenuItem value={5}>5</MenuItem>
                     <MenuItem value={6}>6</MenuItem>
               
                   </Select>
                 </FormControl> 
                 </FormGroup>
                 <hr></hr>  
                  <br></br>
                 <FormGroup row className={classes.formgroup}>

              <FormControl
                   style={{
                     minWidth: 240,
                     marginTop: 16,
                     marginRight: 32,
                     marginLeft: 8,
                   }}
                 >
                   <InputLabel id="psgu">Explaining Destination</InputLabel>
                   <Select
                     displayEmpty
                     classname={classes.textField2}
                     labelId="psgu"
                     disabled={role=="Admin" || role=="Manager"?0:1}
                     value={calldata.explanation}
                     onChange={(e) =>
                       setcalldata({ ...calldata, explanation: e.target.value })
                     }
                   >
                     <MenuItem value={null}>Clear</MenuItem>
                    <MenuItem value={0}>0</MenuItem>
                     <MenuItem value={1}>1</MenuItem>
                     <MenuItem value={2}>2</MenuItem>
                     <MenuItem value={3}>3</MenuItem>
                     <MenuItem value={4}>4</MenuItem>
                     <MenuItem value={5}>5</MenuItem>
                     <MenuItem value={6}>6</MenuItem>
                     <MenuItem value={7}>7</MenuItem>
                     <MenuItem value={8}>8</MenuItem>
                     <MenuItem value={9}>9</MenuItem>
                     <MenuItem value={10}>10</MenuItem>
                  
                   </Select>
                 </FormControl> 
                  <FormControl
                   style={{
                     minWidth: 240,
                     marginTop: 16,
                     marginRight: 32,
                     marginLeft: 8,
                   }}
                 >
                   <InputLabel id="guidance">Guidance</InputLabel>
                   <Select
                     displayEmpty
                     classname={classes.textField2}
                     labelId="guidance"
                     disabled={role=="Admin" || role=="Manager"?0:1}
                     value={calldata.guidance}
                     onChange={(e) =>
                       setcalldata({ ...calldata, guidance: e.target.value })
                     }
                   >
                     <MenuItem value={null}>Clear</MenuItem>
                    <MenuItem value={0}>0</MenuItem>
                     <MenuItem value={1}>1</MenuItem>
                     <MenuItem value={2}>2</MenuItem>
                     <MenuItem value={3}>3</MenuItem>
                     <MenuItem value={4}>4</MenuItem>
                     <MenuItem value={5}>5</MenuItem>
                     <MenuItem value={6}>6</MenuItem>
                     <MenuItem value={7}>7</MenuItem>
                   <MenuItem value={8}>8</MenuItem>
                    <MenuItem value={9}>9</MenuItem>
                     <MenuItem value={10}>10</MenuItem>
                      <MenuItem value={11}>11</MenuItem>
                       <MenuItem value={12}>12</MenuItem>
                        <MenuItem value={13}>13</MenuItem>
                         <MenuItem value={14}>14</MenuItem>
                          <MenuItem value={15}>15</MenuItem>
                           
                   </Select>
                 </FormControl> 
                  <FormControl
                   style={{
                     minWidth: 240,
                     marginTop: 16,
                     marginRight: 32,
                     marginLeft: 8,
                   }}
                 >
                   <InputLabel id="empathy">Sales pitch</InputLabel>
                   <Select
                     displayEmpty
                     classname={classes.textField2}
                     labelId="empathy"
                     disabled={role=="Admin" || role=="Manager"?0:1}
                     value={calldata.sales_pitch}
                     onChange={(e) =>
                       setcalldata({ ...calldata, sales_pitch: e.target.value })
                     }
                   >
                     <MenuItem value={null}>Clear</MenuItem>
                    <MenuItem value={0}>0</MenuItem>
                     <MenuItem value={1}>1</MenuItem>
                     <MenuItem value={2}>2</MenuItem>
                     <MenuItem value={3}>3</MenuItem>
                     <MenuItem value={4}>4</MenuItem>
                     <MenuItem value={5}>5</MenuItem>
                    
               
                   </Select>
                 </FormControl> 
                 </FormGroup>
                 <hr></hr> 
                  <br></br>
                    <FormGroup row className={classes.formgroup}>

                        <TextField variant="outlined"  label="Description"  value={calldata.description} className={classes.textArea} fullWidth multiline rows={2} onChange={(e)=> setcalldata({...calldata, description: e.target.value})}/>
              
                             <TextField variant="outlined"  label="AoI"  value={calldata.improvement} className={classes.textArea} fullWidth multiline rows={2} onChange={(e)=> setcalldata({...calldata, improvement: e.target.value})}/>
                 </FormGroup>
                 <hr></hr> 
                  <br></br>
                 <Button
            variant="contained"
            color="primary"
            onClick={handleSubmit}
            className={classes.button}
          >
            Save
          </Button>
      </Dialog>
    
    {showlead?(<div>

    <FormGroup row className={classes.formgroup}>
        <FormControl style={{minWidth: 480, marginTop: 16, marginRight: 32, marginLeft: 8}}>
            <InputLabel id="Destination">Destination</InputLabel>
                <Select displayEmpty className={classes.textField} InputLabelProps={{ shrink: true }} labelId="Destination" value={leadfilterData.destination} onChange={(e)=> setleadfilterData({...leadfilterData, destination: e.target.value})}>
                
                {dest.map((dest) => {
                return <MenuItem value={dest}>{dest}</MenuItem>;
              })}
                    
                    
                
                </Select>
                </FormControl>
        <Button
            href={leadfilterData.destination=="Sri Lanka"?("/knowledge/"+leadfilterData.destination.split(" ").join("")):"/knowledge/"+leadfilterData.destination}
            variant="contained"
            target="_blank"
            color="inherit"
            className={classes.smallbutton2}
          >
            Go
          </Button>
          <Button
          onClick={sendnonumbermail}
          variant="contained"
          color="primary"
          className={classes.smallbutton}
        >
          <h6>Wrong number mail</h6>
        </Button>
        {newgetqualitylead(leadData)=="Titanium"?(
        <Button
          //href={"tel:+91" + tripData.primary_mobile_number}
          onClick={verifycall}
          variant="contained"
          color="secondary"
          align="right"
          className={classes.smallbutton}
        >
        
          <h6>{"Support Verified"}</h6>
        </Button>
      ):(<Button
          //href={"tel:+91" + tripData.primary_mobile_number}
          onClick={apicall}
          variant="contained"
          color="secondary"
          align="right"
          className={classes.smallbutton}
        >
        
          <h6>{"only_whatsapp" in leadData && leadData.only_whatsapp?"Whatsapp Only":"Call"}</h6>
        </Button>)}
        <Button
          onClick={dialogopen5}
          variant="contained"
          color="inherit"
          align="right"
          className={classes.smallbutton}
        >
          <h6>Call History</h6>
        </Button>
        <Button
          onClick={()=>setOpen5(true)}
          variant="contained"
          color="inherit"
          align="right"
          className={classes.smallbutton}
        >
          <h6>Next Step</h6>
        </Button>
         <Button
                  onClick={()=>sendwa()}
                  variant="contained"
                  color="secondary"
                  align="right"
                  className={classes.smallbutton}
                >
                  <h6>FR WA</h6>
                </Button>
         <Button
                  onClick={()=>viewstatushistory()}
                  variant="contained"
                  color="secondary"
                  align="right"
                  className={classes.smallbutton}
                >
                  <h6>View SH</h6>
                </Button>

        
        </FormGroup>
        {newgetqualitylead(leadData)=="Titanium"?"Verified by Support team":""}
      <Typography variant="h6" align="center" className={classes.headertext}>
        {" "}
        Update Lead (Lead ID:{leadData.lead_id} uploaded on{" "} 
        {new Date(leadData.createdAt).toLocaleString().split(",").slice(0,1)} at {new Date(leadData.createdAt).toLocaleString().split(",").slice(1,2)}|| Assigned to {leadData.lead_owner} on {new Date(leadData.assignedAt).toLocaleString().split(",").slice(0,1)} at {new Date(leadData.assignedAt).toLocaleString().split(",").slice(1,2)} by {leadData.lead_assigned_by}) || {role=="Admin"?newgetqualitylead(leadData)+" "+leadData.lead_place_count:""} || FR WA:{leadData.fast_reach_whatsapp?"true":""}
      </Typography>
      <Typography variant="h6" align="center" className={classes.headertext}>Looker:Destination, date, pax, budget - if less than 2 is confirmed then its a looker OR if customer claims that he wants info only the he is a looker</Typography>
      {"ref_code" in leadData?(
      <BlinkingText variant="h6" align="center" className={classes.headertext}>{leadData.ref_code}</BlinkingText>
      ):("")}
      <form >
        <FormGroup row className={classes.formgroup}>
          <TextField
            disabled
            variant="outlined"
            label="Name"
            value={leadData.lead_name}
            className={classes.textField}
          />
          {role && !(role=="Admin" || role=="TL" || role=="Manager")?(""):(<div>
          {role=="Admin" || role=="TL" || role=="Manager" ?(
          <TextField
            disabled
            variant="outlined"
            label="Mobile"
            value={leadData.mobile_number}
            className={classes.textField}
          />
          ):(<div>
            {Attempted && (cuser && "lead_owner" in leadData && cuser==leadData.lead_owner)?(
              <TextField
            disabled
            variant="outlined"
            label={"only_whatsapp" in leadData && leadData.only_whatsapp?"Mobile number - Whatsapp Only":"Mobile number"}
            value={leadData.mobile_number}
            className={classes.textField}
          />
            ):("")}
          </div>
          )}
          </div>)}
          <TextField
            // disabled={((role=="Support" || role=="Admin") && q=="Iron" && leadData.quality_upgrade)?0:1}
            disabled
            variant="outlined"
            label="Email"
            value={leadData.email_id}
            className={classes.textField}
          />
        </FormGroup>
        <FormGroup row className={classes.formgroup}>
          <TextField
            disabled
            variant="outlined"
            label="Source"
            value={leadData.lead_platform}
            className={classes.textField}
          />
          <TextField
            disabled
            variant="outlined"
            label="Campaign"
            value={leadData.lead_campaign}
            className={classes.textField}
          />
          {role=="Marketing" || role=="Admin" || role=="Sales Support"?(
            <FormControl
                      style={{
                        minWidth: 450,
                        marginTop: 16,
                        marginRight: 32,
                        marginLeft: 5,
                      }}
                    >
                      <InputLabel id="primary destination">
                        Primary Destination
                      </InputLabel>
                      <Select
                        displayEmpty
                        classname={classes.textField}
                        labelId="primary destination"
                        required
                        value={leadData.lead_destination}
                        onChange={(e) =>
                          setleadData({
                            ...leadData,
                            lead_destination: e.target.value,
                          })
                        }
                      >
                        {dest.map((dest) => {
                          return <MenuItem value={dest}>{dest}</MenuItem>;
                        })}
                      </Select>
                    </FormControl>
          ):(
            <TextField
            variant="outlined"
            label="Destination"
            value={leadData.lead_destination}
            className={classes.textField}
          />
          )}
        
  
        </FormGroup>
        <FormGroup row className={classes.formgroup}>
          <TextField
            disabled
            variant="outlined"
            label="Travel Date Decided?"
            value={leadData.lead_travel_date_decided}
            className={classes.textField}
          />
          <TextField
            disabled
            variant="outlined"
            label="Date"
            value={leadData.lead_travel_date}
            className={classes.textField}
          />
          <TextField
            disabled
            variant="outlined"
            label="Passengers"
            value={leadData.lead_child?(leadData.lead_pax+" Adults + "+leadData.lead_child+" Child"):(leadData.lead_pax+" Adults")}
            className={classes.textField}
          />
        </FormGroup>
        <FormGroup row className={classes.formgroup}>
        <TextField
            disabled
            variant="outlined"
            label="Budget"
            value={leadData.lead_budget}
            className={classes.textField}
          />
          <TextField
            disabled
            variant="outlined"
            label="Status"
            value={leadData.lead_status}
            className={classes.textField}
          />
           <TextField
            disabled
            variant="outlined"
            InputLabelProps={{ shrink: true }}
            label="Time to book"
            value={leadData.time_to_book}
            className={classes.textField}
          />
          
          {/* <TextField disabled={role=="Admin"?0:1} variant="outlined"  label="Owner"   value={leadData.lead_owner} className={classes.textField}  onChange={(e)=> setleadData({...leadData, lead_owner: e.target.value})}/> */}
        </FormGroup>
        <FormGroup row className={classes.formgroup}>
        <FormControl
            style={{
              minWidth: 480,
              marginTop: 16,
              marginRight: 32,
              marginLeft: 8,
            }}
          >
            <InputLabel id="owner">Owner</InputLabel>
            <Select
              disabled={cuser=="JatinSejwal" && leadData.model_beta=="Beta"?0:(leadData.model_beta=="Beta"?1:((role == "Admin" || role=="Manager" || role=="Product"  || role=="TL" || role=="Sales Support")? 0 : 1))}
              className={classes.textField}
              labelId="owner"
              required
              value={leadData.lead_owner}
              onChange={(e) =>
                setleadData({ ...leadData, lead_owner: e.target.value })
              }
            >
            <MenuItem value="Amit">Amit</MenuItem>
            <MenuItem value="Abhishek">Abhishek</MenuItem>
            <MenuItem value="RohitS">RohitS</MenuItem>
              {emp.map((emp) => {
                return <MenuItem value={emp}>{emp}</MenuItem>;
              })}
            </Select>
            <FormHelperText className={classes.red}>TL can assign leads within his/her own team</FormHelperText>
          </FormControl>
        <TextField
            disabled
            InputLabelProps={{ shrink: true }}
            variant="outlined"
            label="Flight Required?"
            value={leadData.flight_required}
            className={classes.textField}
          />
          <TextField
            disabled
            InputLabelProps={{ shrink: true }}
            variant="outlined"
            label="Source Airport"
            value={leadData.lead_source_airport}
            className={classes.textField}
          />
        </FormGroup>
        <FormGroup row className={classes.formgroup}>
        <TextField variant="outlined"  label="Description"  disabled={role=="Admin" || role=="Marketing" || role=="Sales Support"?0:1} InputLabelProps={{ shrink: true }} value={"lead_notes" in leadData && leadData.lead_notes.length>0?leadData.lead_notes.replace("%20", " "):""} className={classes.textArea} fullWidth multiline rows={4} onChange={(e) =>
                setleadData({ ...leadData, lead_notes: e.target.value })
              }/>
        </FormGroup>
      
      </form>
              </div>):(<div><p>You do not have access to view this lead</p></div>)}

      {role=="Admin" || role=="Marketing"?(<div>
       <p>Initial Quality:{newgetqualitylead(leadData, true)} || {newgetqualitylead(leadData)}</p>
        <p>Current URL:{leadData.current_url}</p>
        <p>Previous URL:{leadData.previous_url}</p>
        
        <br></br>
         <p>Campaign:{"lead_campaign" in leadData?leadData.lead_campaign:""}</p>
          <p>Platform:{"lead_platform" in leadData?leadData.lead_platform:""}</p>
           <p>Sub platform:{"lead_sub_platform" in leadData?leadData.lead_sub_platform:""}</p>
            <p>Ad:{"lead_ad" in leadData?leadData.lead_ad:""}</p>
            <p>Landing Page:{"landing_page" in leadData?leadData.landing_page:""}</p>
            <p>Cancelled:{"cust_create" in leadData?!leadData.cust_create:""}</p>
            <p>Created By:{"created_by" in leadData?leadData.created_by:""}</p>
            <p>Model:{"model_beta" in leadData?leadData.model_beta:""}</p>
      </div>):("")}
        <Dialog
              
              maxWidth="m"
              open={showsh}
              onClose={()=>setshowsh(false)}
            >
            <TableContainer>
            <Table border="1">
            <TableHead>
            <TableRow>
              <TableCell>
                New Owner
              </TableCell>
              <TableCell>
                Date
              </TableCell>
              <TableCell>
                Changed By
              </TableCell>
            </TableRow>
            </TableHead>
             <TableBody>
              {"change_history" in leadData && leadData.change_history.map((data, index)=><div>
                <TableRow key={index}>
                <TableCell>
                {data.new_owner}
              </TableCell>
                <TableCell>
                {data.changedAt}
              </TableCell>
              <TableCell>
              {data.changed_by}
              </TableCell>
                </TableRow>
              </div>)}
              </TableBody>
              </Table>
              </TableContainer>
            </Dialog>
    </Paper>):("")}
    </div>
  );
};

export default Leaddataupdate;
